<template>
  <span>
    <button
      class="btn btn-link text-blue"
      v-b-modal="'risks-modal' + _uid"
      title="Mérlegelendő kockázatok"
    >
      <i class="fa-solid fa-file-invoice fa-xl"></i
      ><br v-if="commentLineBreak" />Mérlegelendő kockázatok
    </button>
    <b-modal :id="'risks-modal' + _uid">
      <template slot="modal-header">
        <h4 class="modal-title">Mérlegelendő kockázatok</h4>
        <a class="btn-close" @click="$bvModal.hide('risks-modal' + _uid)"></a>
      </template>
      <h5>A Területvezető részéről</h5>
      <ul>
        <li>A munkakörnyezet megfelelősége</li>
        <li>
          Történik-e a munkaterületen más munkavégzés, mely befolyásolhatja a
          munkavégzést?
        </li>
        <li>
          Az alábbi kockázatok nem merülnek fel a területen:
          <ul>
            <li>mozgó berendezésbe becsípődés, burkolási hiányosságok</li>
            <li>nyilvánvaló botlásveszély, beesésveszély (pl. födém nyílás)</li>
            <li>
              magasból, gépről, járműről leesés, kollektív védőeszközök (pl.:
              korlát) hiánya
            </li>
            <li>valamilyen álló, mozgó vagy leeső tárgy sérülésveszélye</li>
            <li>
              a munkavégzés valamilyen anyaghalmon történik és fennáll a
              betemetődés, fulladás veszélye
            </li>
            <li>tűz vagy robbanás veszélye</li>
            <li>veszélyes anyaggal történő kapcsolatba kerülés veszélye</li>
            <li>érintésvédelmi kockázatok</li>
            <li>gépjármű közlekedés a területen</li>
          </ul>
        </li>
      </ul>
      <h5>A Projektvezető részéről:</h5>
      <ul>
        <li>A munkakörnyezet, időjárási viszonyok megfelelősége</li>
        <li>
          A munkavállalók kellő információval és jogosultsággal rendelkeznek a
          feladat elvégzéséhez?
        </li>
        <li>
          Minden szerszám, felszerelés, munkaeszköz, védőeszköz a munkavállalók
          rendelkezésére áll a feladat biztonságos végrehajtására? A felsoroltak
          munkavégzésre alkalmasak, állapotuk megfelelő, biztonságos?
        </li>
        <li>
          Minden lehetséges veszélyt jelentő energiaforrás kizárásra
          kerül/került? (LOTOTO)
        </li>
        <li>
          A munkaterületen nincs olyan munkavédelmi kockázat, amely befolyásolja
          a munkavégzést?
        </li>
        <li>mozgó berendezésbe becsípődés, burkolási hiányosságok</li>
        <li>nyilvánvaló botlásveszély, beesésveszély</li>
        <li>
          magasból, gépről, járműről leesés, kollektív védőeszközök (pl.:
          korlát) hiánya
        </li>
        <li>valamilyen álló, mozgó vagy leeső tárgy sérülésveszélye</li>
        <li>
          a munkavégzés valamilyen anyaghalmon történik és fennáll a
          betemetődés, fulladás veszélye
        </li>
        <li>tűz vagy robbanás veszélye</li>
        <li>veszélyes anyaggal történő kapcsolatba kerülés veszélye</li>
        <li>érintésvédelmi kockázatok</li>
        <li>gépjármű közlekedés a területen</li>
      </ul>
      <template #modal-footer="{ ok }">
        <b-button size="sm" variant="success" @click="ok()"> Rendben </b-button>
      </template>
    </b-modal>
  </span>
</template>

<script>
export default {
  props: {
    commentLineBreak: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
